import React from 'react';
import { useRequest } from 'hooks';
import { useParams } from 'react-router-dom';

import { GRADE_STUDENT_STATES } from 'utils/Constants';

import Category from 'components/Ui/Category';
import { Form, Button, Select } from 'components/Misc/Form';

import { useGradeReportStore } from 'store/grade/useGradeReportStore';

const State = ({ studentId, grade }) => {
	// Cache current grade's id
	const { id } = useParams();

	// Store create and update requests
	const [[progress], request] = useRequest('put', `grades/${id}`);

	// Use grade report store
	const onChangeGrade = useGradeReportStore(state => state.onChangeGrade);

	// Handle input's value change
	const onChange = (change) => onChangeGrade(studentId, change);

	// Handle report's creation or update
	const onSubmit = async (event) => {
		event.preventDefault();

		// Try to update student's state
		await request({
			studentId: studentId,
			state: grade.state
		}, {
			related: 'student:state'
		});
	};

	return (
		<Category title="Klases statuss" hide>
			<Form onSubmit={onSubmit} className="grid grid-cols-2 gap-4">
				<Select
					name="state"
					label="Statuss"
					value={grade.state}
					onChange={onChange}
					options={GRADE_STUDENT_STATES.map(state => ({
						value: state.value,
						name: state.text
					}))}
				/>

				<div className="flex justify-end items-end">
					<Button
						submit
						icon="done"
						value="Saglabāt"
						theme="success"
						progress={progress}
					/>
				</div>
			</Form>
		</Category>
	);
};

export default State;